import React from 'react';
import pluralize from '../../../../../../../utils/pluralize';
import {
  StyledColorName,
  StyledColorPill,
  StyledPillContainer,
  StyledPillWrapper,
} from '../styles/ColorFilterPill.styles';
import { extractAppliedFilters } from '../../../utils';
import { capitalizeFirstWordOfSentence } from '../../../../../../../utils/utils.web';

const ColorFilterPill = ({ item, handleClick, appliedFilters, facetName }) => {
  const selected = extractAppliedFilters(appliedFilters, facetName)?.includes(item?.value);
  return (
    <StyledPillContainer>
      <StyledPillWrapper
        className="color-click"
        onClick={(e) => {
          e.preventDefault();
          handleClick(facetName, item?.value);
        }}
      >
        <StyledColorPill
          className={`svg-color ${selected ? 'outline selected-color' : item?.class}`}
          imgData={item.imageData}
          imgConfigs={item.imageConfig}
          data-colorname={item.colorName}
        />
        <StyledColorName className="grids color-name" fontSize={['fs12']} fontFamily="secondary">
          {capitalizeFirstWordOfSentence(pluralize(item.title?.toLowerCase()))}
        </StyledColorName>
      </StyledPillWrapper>
    </StyledPillContainer>
  );
};

export default ColorFilterPill;
